import React, { FC } from "react";

import Typography from "@mui/material/Typography";

import InfoBox from "components/InfoBox";
import { INFO_BOX_TYPE } from "components/InfoBox/types";
import Card from "components/Card";

interface PhysicalRedeemedInfoProps {
  redeemHash?: string;
}

const PhysicalRedeemedInfo: FC<PhysicalRedeemedInfoProps> = ({
  redeemHash,
}) => {
  return (
    <Card bg="plain">
      <Typography component="h4" variant="h4" gutterBottom>
        PHYSICAL
      </Typography>
      {redeemHash ? (
        <Typography mb={2}>
          This item has been already redeemed to the physical form. Check the
          details of the physical item.
        </Typography>
      ) : (
        <InfoBox type={INFO_BOX_TYPE.INFO}>
          You've successfully completed the payment. The transaction is now
          being processed on blockchain, wait a few minutes to check the
          physical item details.
        </InfoBox>
      )}
    </Card>
  );
};

export default PhysicalRedeemedInfo;
